import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authModalOpen, setAuthModalOpen] = useState(false);

  const check = useCallback(async () => {
    try {
      const { data } = await authApi.me();
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Emergent OAuth, AuthCallback handles it — skip here
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    check();
  }, [check]);

  const signup = async (email, password, name) => {
    const { data } = await authApi.signup(email, password, name);
    localStorage.setItem("4ever_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => {
    const { data } = await authApi.login(email, password);
    localStorage.setItem("4ever_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem("4ever_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{
      user, loading, signup, login, logout,
      openAuth: () => setAuthModalOpen(true),
      closeAuth: () => setAuthModalOpen(false),
      authModalOpen, refreshUser: check,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
